<template>
  <v-card class="mx-auto pa-4 pb-0">
    <v-row class="ma-0">
      <v-col cols="12" sm="8">
        <v-row class="d-flex" style="place-content: center">
          <h2>{{ title }}</h2>
        </v-row>
        <div class="titulo-detail px-4" style="v-cardAdd">
          Informações gerais:
        </div>
        <v-divider></v-divider>
        <v-row class="pa-0 ma-0">
          <v-col cols="12" sm="4" md="4" lg="4">
            <p class="label-details ma-0">Código do cupom:</p>
            <span class="details-text">{{ this.currentCoupon.code }}</span>
          </v-col>

          <v-col cols="12" sm="4" md="4" lg="4">
            <div>
              <p class="label-details ma-0">Data de criação:</p>
              <span class="details-text">{{
                formatDate(this.currentCoupon.created_at)
              }}</span>
            </div>
          </v-col>

          <v-col cols="12" sm="4" md="4" lg="4">
            <div>
              <p class="label-details ma-0">Período:</p>
              <span class="details-text">{{
                this.currentCoupon.validate_end != null
                  ? formatDate(this.currentCoupon.validate_end)
                  : this.currentCoupon.period == 1
                  ? "Indeterminado"
                  : "sem data mas determinado"
              }}</span>
            </div>
          </v-col>

          <v-col cols="12" sm="4" md="4" lg="4">
            <div>
              <p class="label-details ma-0">Descrição:</p>
              <span class="details-text">{{
                this.currentCoupon.description
              }}</span>
            </div>
          </v-col>
          <v-col cols="12" sm="4" md="4" lg="4">
            <div>
              <p class="label-details ma-0">Utilizados:</p>
              <span class="details-text"
                >{{ orders ? orders.length : "Sem registro" }} cupons</span
              >
            </div>
          </v-col>
          <v-col cols="12" sm="4" md="4" lg="4">
            <div>
              <p class="label-details ma-0">Vencimento:</p>
              <span class="details-text">{{
                this.currentCoupon.validate_end != null
                  ? formatDate(this.currentCoupon.validate_end)
                  : "Indeterminado"
              }}</span>
            </div>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <div class="titulo-detail px-4" style="v-cardAdd">Desconto:</div>
        <v-divider></v-divider>
        <v-row class="pa-0 ma-0 pb-2">
          <v-col cols="12" sm="4" md="4" lg="4">
            <p class="label-details ma-0">Valor:</p>
            <span class="details-text">{{
              this.currentCoupon.benefit == 2
                ? "R$" + this.currentCoupon.descontoReais
                : this.currentCoupon.descontoPercentual + "%"
            }}</span>
          </v-col>

          <v-col cols="12" sm="4" md="4" lg="4">
            <div>
              <p class="label-details ma-0">Tipo de beneficio:</p>
              <span class="details-text">{{
                this.currentCoupon.type == 0
                  ? "Produtos Selecionados"
                  : this.currentCoupon.type == 1
                  ? "Toda Loja"
                  : this.currentCoupon.type == 2
                  ? "Clientes Selecionados"
                  : this.currentCoupon.type == 3
                  ? "Categoria selecionada"
                  : this.currentCoupon.type == 4
                  ? "Subcategoria selecionada"
                  : this.currentCoupon.type == 5
                  ? "Produto selecionado"
                  : "Toda Loja"
              }}</span>
            </div>
          </v-col>

          <v-col cols="12" sm="4" md="4" lg="4">
            <div>
              <p class="label-details ma-0">Quantidade de Cupons:</p>
              <span class="details-text">{{
                this.currentCoupon.quantity
              }}</span>
            </div>
          </v-col>

          <v-col cols="12" sm="4" md="4" lg="4">
            <div>
              <p class="label-details ma-0">Preço mínimo para uso:</p>
              <span class="details-text">{{
                this.currentCoupon.minimum_price
                  ? this.currentCoupon.minimum_price
                  : "Sem registros"
              }}</span>
            </div>
          </v-col>
          <v-col
            v-if="this.currentCoupon.type == 2"
            cols="12"
            sm="4"
            md="4"
            lg="4"
          >
            <div>
              <p class="label-details ma-0">Email cliente:</p>
              <span class="details-text">{{
                this.currentCoupon.email
                  ? this.currentCoupon.email
                  : "Sem registros"
              }}</span>
            </div>
          </v-col>

          <v-col cols="12" sm="4" md="4" lg="4">
            <div>
              <p class="label-details ma-0">Datas disponíveis:</p>
              <span class="details-text">{{ "Todos os dias da semana" }}</span>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="4">
        <v-simple-table class="mt-6" height="300">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-center">Pedido</th>
                <th class="text-left">Valor</th>
                <th class="text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="orders && orders.length == 0" class="text-center">
                <td colspan="3">Nenhum dado encontrado</td>
              </tr>
              <tr v-for="item in orders" :key="item.name">
                <td class="text-center">
                  <a target="_blank" :href="`/order-detail?id=${item.id}`">{{
                    item.orderCode
                  }}</a>
                  <br />
                  {{ formatDate(item.created_at) }}
                </td>
                <td>
                  {{
                    item.totalPrice
                      ? item.totalPrice.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })
                      : "Sem registro"
                  }}
                </td>
                <td>{{ orderStatus[item.orderStatus] }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

    <v-col cols="12" md="12" sm="12" class="d-flex justify-center">
      <v-btn large class="secondary-button" @click="close" :loading="loading">
        <span>FECHAR</span>
      </v-btn>
    </v-col>
  </v-card>
</template>

<style scoped>
@media (max-width: 600px) {
  .select-type {
    width: 90% !important;
  }
}

.form {
  display: flex;
  justify-content: center;
}

@media (max-width: 600px) {
  .form {
    flex-direction: column;
  }
}

.label-details {
  font-family: Roboto;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 27px;

  letter-spacing: 0.15px;

  color: #232021;
}

.details-text {
  color: #232021;
  font-family: Roboto;
  font-style: normal;
  font-size: 13px;
  line-height: 25px;
}

.titulo-detail {
  color: black;
  font-family: Roboto;
  font-style: normal;
  font-size: 17px;
  line-height: 40px;
  font-weight: bold;
}
</style>

<script>
import ApiService from "../../../services/ApiService";
import Vue from "vue";
import moment from "moment";

export default {
  props: {
    title: String,
    coupon: Object,
  },

  created() {
    if (this.coupon) {
      this.getOrders();
      this.isEditing = true;
      this.currentCoupon = {
        id: this.coupon.id,
        code: this.coupon.code,
        email: this.coupon.email,
        created_at: this.coupon.created_at,
        status: this.coupon.status,
        benefit: this.coupon.benefit,
        description: this.coupon.description,
        descontoReais: this.coupon.descontoReais,
        descontoPercentual: this.coupon.descontoPercentual,
        type: this.coupon.type,
        quantity: this.coupon.quantity,
        minimum_price: this.coupon.minimum_price,
        validate_end: this.coupon.validate_end,
        validate_initial: this.coupon.validate_initial,
        period: this.coupon.period,
        updated_at: this.coupon.updated_at,
        email: this.coupon.email,
        used: this.coupon.used,
      };
    }
  },

  data: () => ({
    orderStatus: [
      "Novo", //Novos
      "Aguardando", //Aguardando confirmação de pagamento
      "Reprovado", //Recusou o pagamento e estoque
      "Aprovado", //Aprovou o pagamento e estoque
      "Enviado", //Em trânsito
      "Devolvido", // Cliente pediu extorno ou troca
      "Separacao",
      "Cancelado", //Cancelado
      "Entregue", //Entregue
      "Retirar", //Entregue
      "GerarEtiqueta", //Entregue
    ],
    orders: [],
    currentCoupon: [],
    dialogKey: false,
    loading: false,
    error: false,
    isEditing: false,
    stores: [],
    filter: {
      page: 1,
      pageSize: 15,
      status: null,
      updated_at: null,
    },
    status: [
      { label: "Inativo", value: 0 },
      { label: "Ativo", value: 1 },
    ],
    apiService: new ApiService(),
  }),

  methods: {
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY hh:mm");
    },

    getOrders() {
      this.apiService
        .get(`coupon/orders/${this.coupon.id}`)
        .then((response) => {
          this.orders = response.content;
        });
    },

    close() {
      this.$emit("close");
    },

    action() {
      this.$emit("action");
    },
  },
};
</script>
